@if(networkName | async; as networkName) {
<div class="bp-modal mod-lg wrapper">
	<bp-modal-header [title]="'congratulations' | translate" class="font-semibold">
		<button
			class="cancel-button"
			right
			(click)="onCancelButtonClick()"
			(keydown.enter)="onCancelButtonClick()"
			[tabIndex]="0">
			<strong>{{ "close" | translate }}</strong>
		</button>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section">
			<div class="bp-modal-description">
				<div>
					<img class="img-success" src="assets/images/check-mark-filled.svg" />
				</div>
				<div class="title">{{ "send_in_progress" | translate }}</div>
				<p class="info-title">
					{{
						"send_in_progress_info"
							| translate
								: [
										cryptoTransaction.getAmount().toString(),
										cryptoTransaction.cryptocoin_symbol | uppercase,
										cryptoTransaction.getCurrentFiatAmount(),
										defaultFiatSymbol
								  ]
					}}
				</p>
			</div>
			<button (click)="done()" class="btn btn-primary btn-lg mod-button-width button-done" type="button">
				{{ "done" | translate }}
			</button>
		</div>
	</div>
</div>
}
